// extracted by mini-css-extract-plugin
export var disabled = "g2_bZ";
export var tabs = "g2_pC";